import { Download, FileText, ExternalLink, Clock } from "lucide-react";
import { DOCUMENTS } from "../data/brand";

export default function DocumentsGrid() {
  return (
    <section
      id="documenti"
      data-testid="documents-section"
      className="section bg-slate-50 border-y border-slate-200"
    >
      <div className="container-90">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-14 items-end">
          <div className="lg:col-span-8">
            <div className="overline mb-4">Trasparenza · Documenti ufficiali</div>
            <h2 className="font-heading text-3xl sm:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.05]">
              Documenti Informativi
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-slate-600 leading-relaxed">
              Consulta e scarica la documentazione ufficiale della nostra società di
              brokeraggio assicurativo.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {DOCUMENTS.map((doc) => (
            <DocumentCard key={doc.id} doc={doc} />
          ))}
        </div>
      </div>
    </section>
  );
}

function DocumentCard({ doc }) {
  const Icon = doc.external ? ExternalLink : FileText;
  const isPending = !!doc.pending;

  const Wrapper = ({ children }) => {
    if (isPending) {
      return (
        <div
          data-testid={`document-${doc.id}-card`}
          aria-disabled="true"
          className="block bg-white border border-slate-200 p-7 opacity-90 cursor-not-allowed flex flex-col h-full"
        >
          {children}
        </div>
      );
    }
    return (
      <a
        href={doc.url}
        target={doc.external ? "_blank" : "_self"}
        rel="noopener noreferrer"
        download={!doc.external}
        data-testid={`document-${doc.id}-card`}
        className="group block bg-white border border-slate-200 hover:border-[color:var(--brand-blue)] p-7 transition-all hover:-translate-y-1 hover:shadow-lg flex flex-col h-full"
      >
        {children}
      </a>
    );
  };

  return (
    <Wrapper>
      <div className="flex items-start justify-between mb-6">
        <div className="w-12 h-12 bg-[color:var(--brand-blue)] flex items-center justify-center">
          <Icon className="w-5 h-5 text-white" strokeWidth={1.5} />
        </div>
        <span className="text-[0.65rem] uppercase tracking-[0.18em] font-bold text-slate-400">
          {doc.size}
        </span>
      </div>

      <div className="flex-1">
        <div className="text-xs uppercase tracking-[0.18em] font-bold text-[color:var(--brand-blue)] mb-2">
          {doc.subtitle}
        </div>
        <h3 className="font-heading text-xl font-bold text-slate-900 mb-3 leading-tight">
          {doc.title}
        </h3>
        <p className="text-sm text-slate-600 leading-relaxed mb-6">
          {doc.description}
        </p>
      </div>

      <div className="pt-4 border-t border-slate-200 flex items-center justify-between text-sm font-semibold">
        {isPending ? (
          <span className="inline-flex items-center gap-2 text-slate-500">
            <Clock className="w-4 h-4" /> In aggiornamento
          </span>
        ) : doc.external ? (
          <span className="inline-flex items-center gap-2 text-[color:var(--brand-blue)] group-hover:gap-3 transition-all">
            Vai al portale <ExternalLink className="w-4 h-4" />
          </span>
        ) : (
          <span className="inline-flex items-center gap-2 text-[color:var(--brand-blue)] group-hover:gap-3 transition-all">
            Scarica PDF <Download className="w-4 h-4" />
          </span>
        )}
      </div>
    </Wrapper>
  );
}
